import type { AppProps } from 'next/app';
import { AuthProvider } from '@/contexts/auth-context';
import '@/styles/globals.css';

export default function App({ Component, pageProps }: AppProps) {
  return (
    <AuthProvider>
      <Component {...pageProps} />
    </AuthProvider>
  );
}
